import { render } from "./index.vue?vue&type=template&id=3b91ff8a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3b91ff8a&scoped=true&lang=css"

import exportComponent from "/Users/zhaolong/Documents/work/puyan/sichouzhilu/sczl-js-user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b91ff8a"]])

export default __exports__